<template>
 <section>
  <div class="updateForm">
    <p class="control" @click="isScheduleBoard = true">
    <a class="button is-link">
      編集
    </a>
    </p>
      <b-modal width="680px" :active.sync="isScheduleBoard">
        <div class="schedulecard">
          <p>
            スケジュールを編集
          </p>
        <b-field label="タイトル名">
          <b-input v-model="selected.title">
          </b-input>
        </b-field>
         <b-field label="タイムゾーン">
            <b-datepicker
              locale="ja-JP"
              v-model="selected.date"
              placeholder="クリックして選択してください">
            </b-datepicker>
        </b-field>
         <b-field label="開始時刻">
           <b-timepicker
              v-model="updateSchedule.startTime"
              placeholder="クリックして選択してください">
           </b-timepicker>
         </b-field>
         <b-field label="終了時刻">
             <b-timepicker
                v-model="updateSchedule.endTime"
                placeholder="クリックして選択してください"
                :min-time="updateSchedule.startTime">
             </b-timepicker>
         </b-field>
        <button @click="changeSchedule()" v-if="isScheduleBoard">更新</button>
        </div>
      </b-modal>
  </div>
 </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UpdateSchedule',
  componentName: 'UpdateSchedule',
  data () {
    return {
      updateSchedule: {
        startTime: new Date(),
        endTime: new Date()
      },
      isScheduleBoard: false
    }
  },
  computed: {
    ...mapState('calendar', ['schedule', 'selected'])
  },
  methods: {
    changeSchedule () {
      console.debug('*** Start *** changeSchedule')
      this.$store.dispatch('calendar/changeSchedule', this.updateSchedule)
      this.isScheduleBoard = false
      console.debug('*** End *** changeSchedule')
    }
  }
}
</script>

<style scoped>
.schedulecard {
  background-color: white;
}

.updateForm {
  margin: 0px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/UpdateSchedule.vue